import { render, staticRenderFns } from "./AgendaCard.vue?vue&type=template&id=fd01f38a&scoped=true&"
import script from "./AgendaCard.vue?vue&type=script&lang=js&"
export * from "./AgendaCard.vue?vue&type=script&lang=js&"
import style0 from "./AgendaCard.vue?vue&type=style&index=0&id=fd01f38a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd01f38a",
  null
  
)

export default component.exports